import React, {useEffect, useState} from 'react';
import ItemFormDialog from "../form/ItemFormDialog";
import TagBulkDialog from "../form/TagBulkDialog";

function TagDialog(props) {
  const {
    mindfileUserLevel,
    id, open, closeDialog, items, afterItemsChange,
    savingInProgress,
    mindfileFilterValues,
    folderList, addFolder,
    saveItems
  } = props;

  const [tagState, setTagState] = useState({
    tagStates: [],
    tagBulk: false,
  });

  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
      if(!open){
        setTagState({
          tagStates: [],
          tagBulk: false,
        })
      }
      if(loaded && !open){
        setLoaded(false)
      }
    },
    // eslint-disable-next-line
    [open]
  )

  useEffect(() => {
      if(!open){
        return;
      }
      if(!loaded) {
        setTagState({
          tagStates: items ? items.map(item => ({...item, date: item.date || new Date()})) : [],
          tagBulk: items ? items.length > 1 : false,
        });
        setLoaded(true);
      }else{
        const newStates = [...tagState.tagStates];
        let changed = false;
        items.forEach(newItem => {
          let i = newStates.findIndex(item => item.id === newItem.id);
          if(i === -1){
            return;
          }
          const prev = newStates[i];
          if(newItem.url_ts !== prev.url_ts || newItem.conversion !== prev.item_data.conversion){
            changed = true;
            const url = `/mindfiles/${prev.mindfile_id}/show/${prev.item_data_id}/${prev.url_show_hash}/thumbnail?ts=${newItem.url_ts}`
            newStates[i] = {...prev, url_ts: newItem.url_ts, updated_at: newItem.updated_at, item_data:{...prev.item_data, conversion: newItem.conversion}, thumbnail_url:url}
          }
        })
        if(changed){
          setTagState({
            tagStates: newStates,
            tagBulk: tagState.tagBulk
          });
        }
      }
      // setSavingInProgress(false);
    },
    // eslint-disable-next-line
    [items]
  );

  const saveBulk = (updated) => {
    // This is done after setState completes to ensure all the state is synced.
    // setSavingInProgress(true);
    saveItems(updated,
      () => {
        handleTagClose();
      },
      () => {});
  };

  const closeTagDialog = () => {
    closeDialog();
    // setSavingInProgress(false);
  };

  const handleTagClose = () => {
    if(typeof(afterItemsChange) === "function") {
      afterItemsChange();
    }
    closeTagDialog();
  };

  const updateFirstTagState = newState => {
    setTagState({
      ...tagState,
      tagStates: [newState],
    });
  };

  const updateTagStates = newStates => {
    setTagState({
      ...tagState,
      tagStates: newStates
    });
  };

  return (
    <>
      {tagState.tagStates.length === 1 ?
        <ItemFormDialog
          mindfileUserLevel={mindfileUserLevel}
          id={`${id}Single`}
          item={tagState.tagStates[0]}
          itemType={tagState.tagStates[0].itemType}
          handleItemChange={updateFirstTagState}
          keywordsList={mindfileFilterValues.keywords}
          peopleList={mindfileFilterValues.people}
          folderList={folderList}
          addFolder={addFolder}
          title={`Tag ${tagState.tagStates[0].name}`}
          isOpen={open && !tagState.tagBulk}
          handleSave={saveBulk.bind(this, tagState.tagStates)}
          handleCancel={closeTagDialog}
        /> : tagState.tagStates.length > 1 ?
        <TagBulkDialog
          id={`${id}Bulk`}
          isOpen={open && tagState.tagBulk}
          closeDialog={closeTagDialog}
          saveSelected={saveBulk}
          savingInProgress={savingInProgress}
          tagStates={tagState.tagStates}
          updateTagStates={updateTagStates}
          keywordsList={mindfileFilterValues.keywords}
          peopleList={mindfileFilterValues.people}
          folderList={folderList}
          addFolder={addFolder}
        /> : null }
    </>
  );
}

export default TagDialog;
